export default {"src":"/_next/static/media/google-icon.ea51245c.svg","height":45,"width":45};